import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;

export default function useSettings() {
  const [settings, setSettings] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    api.get("/settings").then((r) => { cache = r.data; setSettings(r.data); }).catch(() => {});
  }, []);
  return settings;
}
